import React from 'react';

import Image from '../../Image';
import { CtaButton } from '../HeaderMastheadTwoColumns/HeaderMastheadTwoColumns.styles';
import {
  CircleCtaButton,
  ImageOverlay,
  ImageWrapper,
  Split,
  StyledContainer,
  Subtitle,
  Text,
  Title,
  Wrapper,
} from './HeaderMastheadHalfImage.styles';

const HeaderMastheadHalfImage = ({ headerData }) => {
  const { title, image, subTitle, headerText, linkTitle, ctaUrl, linkTitle2, ctaUrl2 } = headerData;

  return (
    <Wrapper>
      <ImageWrapper>
        <Image image={image[0]} lazyload={false} />
        <ImageOverlay />
      </ImageWrapper>
      <StyledContainer>
        <Title>{title}</Title>
        <Split>
          {subTitle && (
            <div>
              <Subtitle>{subTitle}</Subtitle>
              {linkTitle2 && ctaUrl2 && (
                <CtaButton href={ctaUrl2.url} type={ctaUrl2.type} size="large">
                  {linkTitle2}
                </CtaButton>
              )}
            </div>
          )}
          {headerText && <Text dangerouslySetInnerHTML={{ __html: headerText }} />}
        </Split>
      </StyledContainer>
      {linkTitle && ctaUrl && (
        <CircleCtaButton href={ctaUrl.url} type={ctaUrl.type}>
          {linkTitle}
        </CircleCtaButton>
      )}
    </Wrapper>
  );
};

export default HeaderMastheadHalfImage;
